import {
  exportarClientesGrid,
  useBuscarClientesGrid,
  useBuscarClientesAutoComplete,
} from "../../Scripts/Services/cxc-service.js";

import {
  AutoComplete,
  SelectButton,
  Dropdown,
  addLocale,
  Button,
  Column,
  DataTable,
  Calendar,
  ProgressSpinner,
  FilterMatchMode,
  FilterOperator,
  InputNumber,
  locale,
  Message,
  Row,
  ColumnGroup,
} from 'primereact';
import React, {useEffect, useState} from 'react';
import {createPortal} from "react-dom";
import Exportar from "../../../Commons/Scripts/Componentes/Exportar/Exportar";
import {useTheme} from "../../../Commons/Scripts/Hooks";
import ToolTip from "../../../Commons/Scripts/Componentes/ToolTip/Tooltip";
import {SvgComponent} from "../../../Commons/Scripts/Componentes";
import { Dropdown as Dp, Nav } from 'react-bootstrap';

export const GridCxc = () => {
  addLocale("es", {
    firstDayOfWeek: 1,
    showMonthAfterYear: true,
    dayNames: [
      "domingo",
      "lunes",
      "martes",
      "mi�rcoles",
      "jueves",
      "viernes",
      "s�bado",
    ],
    dayNamesShort: ["dom", "lun", "mar", "mi�", "jue", "vie", "s�b"],
    dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
    monthNames: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    monthNamesShort: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    today: "Hoy",
    clear: "Limpiar",
    equals: "Igual a",
    notEquals: "Diferente a",
    lt: "Menor a",
    lte: "Menor o igual a",
    gt: "Mayor a ",
    gte: "Mayor o igual a",
    is: "Is",
    isNot: "Is Not",
    before: "Before",
    after: "After",
    apply: "Aplicar",
    matchAll: "Coincidir todo",
    matchAny: "Coincidir cualquiera",
    addRule: "Agregar condicion",
    removeRule: "Quitar condicion",
  });
  const monedaPredeterminada = window.monedaPredeterminada;
  const {theme} = useTheme();
  const [showExportar, setShowExportar] = useState(false);
  const colorPrimario = window.colorPrimario;
  const [fechasGrid, setFechasGrid] = React.useState(null);
  // tabla
  const [tiendas, setTiendas] = React.useState([]);
  const [periodoGrid, setPeriodoGrid] = React.useState("mensual");
  const [filtros, setFiltros] = React.useState(null);
  const [cargandoData, setCargandoGrid] = React.useState(true);
  const [gridWhere, setGridWhere] = React.useState({
    where: {
      EsAscendente: false,
      EsOrdernable: true,
      OrderBy: "FacturasMonto",
      IndiceDePagina: 0,
      esFecha: false,
      periodo: periodoGrid,
      ClientesNombresList: tiendas,
    },
  });
  const { data: tiendasGrid, error: errorTiendasGrid } =
    useBuscarClientesGrid(gridWhere);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [lazyState, setlazyState] = React.useState({
    first: 0,
    rows: 10,
    page: 0,
    sortField: "CantidadTotalVentas",
    sortOrder: -1,
    filters: filtros,
  });
  const onPage = (event) => {
    const newWhere = {
      where: {
        ...gridWhere.where,
        fechaInicio: fechasGrid?.[0] ?? null,
        fechaFin: fechasGrid?.[1] ?? null,
        IndiceDePagina: event.page,
      },
    };
    setGridWhere(newWhere);
    setlazyState(event);
    setCargandoGrid(true);
  };
  const onSort = (event) => {
    const newWhere = {
      where: {
        ...gridWhere.where,
        fechaInicio: fechasGrid?.[0] ?? null,
        fechaFin: fechasGrid?.[1] ?? null,
        EsAscendente: event.sortOrder == 1,
        OrderBy: event.sortField,
      },
    };
    setGridWhere(newWhere);
    setlazyState(event);
    setCargandoGrid(true);
  };
  const onFilter = (event) => {
    const filtros = event.filters;
    setlazyState(event);
    const newWhere = {
      where: {
        ...gridWhere.where,
        fechaInicio: fechasGrid?.[0] ?? null,
        fechaFin: fechasGrid?.[1] ?? null,
        ClientesNombresList: filtros.Nombre.value,
        FacturasMontoFiltros: filtros.FacturasMonto.constraints.map((e) => ({
          [e.value]: e.matchMode,
        })),
        FacturasCantidadFiltros: filtros.FacturasCantidad.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        FacturasPromedioFiltros: filtros.FacturasPromedio.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        FacturaPendienteMontoFiltros:
          filtros.FacturaPendienteMonto.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        FacturaPendienteCantidadFiltros:
          filtros.FacturaPendienteCantidad.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        FacturasVencidasMontoFiltros:
          filtros.FacturasVencidasMonto.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        FacturasVencidasCantidadFiltros:
          filtros.FacturasVencidasCantidad.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        FacturasDescuentoMontoFiltros:
          filtros.FacturasDescuentoMonto.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        FacturasDescuentoCantidadFiltros:
          filtros.FacturasDescuentoCantidad.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        FacturaDescuentoPromedioFiltros:
          filtros.FacturaDescuentoPromedio.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        CalidadCreditoFiltros: filtros.CalidadCredito.constraints.map((e) => ({
          [e.value]: e.matchMode,
        })),
        TasaMorosidadFiltros: filtros.TasaMorosidad.constraints.map((e) => ({
          [e.value]: e.matchMode,
        })),
        TasaImpagosFiltros: filtros.TasaImpagos.constraints.map((e) => ({
          [e.value]: e.matchMode,
        })),
        PlazoMedioCobroFiltros: filtros.PlazoMedioCobro.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        TasaResolucionImpagosFiltros:
          filtros.TasaResolucionImpagos.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        NotaCreditoMontoFiltros: filtros.NotaCreditoMonto.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        NotaCreditoCantidadFiltros: filtros.NotaCreditoCantidad.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        NotaCreditoPromedioFiltros: filtros.NotaCreditoPromedio.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        NotaDebitoMontoFiltros: filtros.NotaDebitoMonto.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        NotaDebitoCantidadFiltros: filtros.NotaDebitoCantidad.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        NotaDebitoPromedioFiltros: filtros.NotaDebitoPromedio.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        AnticipoMontoFiltros: filtros.AnticipoMonto.constraints.map((e) => ({
          [e.value]: e.matchMode,
        })),
        AnticipoCantidadFiltros: filtros.AnticipoCantidad.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        AnticipoPromedioFiltros: filtros.AnticipoPromedio.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        RecibosMontoFiltros: filtros.RecibosMonto.constraints.map((e) => ({
          [e.value]: e.matchMode,
        })),
        RecibosCantidadFiltros: filtros.RecibosCantidad.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        RecibosPromedioFiltros: filtros.RecibosPromedio.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        DevolucionesMontoFiltros: filtros.DevolucionesMonto.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        DevolucionesCantidadFiltros:
          filtros.DevolucionesCantidad.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        DevolucionesPromedioFiltros:
          filtros.DevolucionesPromedio.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
      },
    };
    setGridWhere(newWhere);
    setCargandoGrid(true);
  };
  const borrarFiltros = () => {
    const newWhere = {
      where: {
        ...gridWhere.where,
        fechaInicio: fechasGrid?.[0] ?? null,
        fechaFin: fechasGrid?.[1] ?? null,
        ClientesNombresList: null,
        FacturasMontoFiltros: null,
        FacturasCantidadFiltros: null,
        FacturasPromedioFiltros: null,
        FacturaPendienteMontoFiltros: null,
        FacturaPendienteCantidadFiltros: null,
        FacturasVencidasMontoFiltros: null,
        FacturasVencidasCantidadFiltros: null,
        FacturasDescuentoMontoFiltros: null,
        FacturasDescuentoCantidadFiltros: null,
        FacturaDescuentoPromedioFiltros: null,
        CalidadCreditoFiltros: null,
        TasaMorosidadFiltros: null,
        TasaImpagosFiltros: null,
        PlazoMedioCobroFiltros: null,
        TasaResolucionImpagosFiltros: null,
        NotaCreditoMontoFiltros: null,
        NotaCreditoCantidadFiltros: null,
        NotaCreditoPromedioFiltros: null,
        NotaDebitoMontoFiltros: null,
        NotaDebitoCantidadFiltros: null,
        NotaDebitoPromedioFiltros: null,
        AnticipoMontoFiltros: null,
        AnticipoCantidadFiltros: null,
        AnticipoPromedioFiltros: null,
        RecibosMontoFiltros: null,
        RecibosCantidadFiltros: null,
        RecibosPromedioFiltros: null,
        DevolucionesMontoFiltros: null,
        DevolucionesCantidadFiltros: null,
        DevolucionesPromedioFiltros: null,
      },
    };
    setGridWhere(newWhere);
    setCargandoGrid(true);
    initFiltros();
  };
  const initFiltros = () => {
    setFiltros({
      FacturasMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturasCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturasPromedio: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturaPendienteMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturaPendienteCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturasVencidasMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturasVencidasCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturasDescuentoMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturasDescuentoCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturaDescuentoPromedio: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      TasaMorosidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      TasaImpagos: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      CalidadCredito: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      NotaCreditoMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      NotaCreditoCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      NotaCreditoPromedio: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      NotaDebitoMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      NotaDebitoCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      NotaDebitoPromedio: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      AnticipoMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      AnticipoCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      AnticipoPromedio: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      RecibosMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      RecibosCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      RecibosPromedio: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      DevolucionesMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      DevolucionesCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      DevolucionesPromedio: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      TasaResolucionImpagos: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      PlazoMedioCobro: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      Nombre: {
        value: null,
        matchMode: FilterMatchMode.IN,
      },
    });
  };
  const montosFiltroTemplate = (options) => {
    return (
      <InputNumber
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        prefix={monedaPredeterminada}
        locale="en-US"
        minFractionDigits={2}
      />
    );
  };
  const tasasFiltroTemplate = (options) => {
    return (
      <InputNumber
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        suffix="%"
      />
    );
  };
  const CantidadesFiltroTemplate = (options) => {
    return (
      <InputNumber
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
      />
    );
  };
  const NombreFiltroTemplate = (options) => {
    return (
      <AutoComplete
        pt={{
          panel: { style: { width: "400px" } },
        }}
        onClick={(e) => autoCompleteRef.current.search(e, "", "dropdown")}
        ref={autoCompleteRef}
        emptyMessage="No hay resultados disponibles"
        showEmptyMessage="true"
        inputId="ac"
        value={options.value}
        multiple
        suggestions={dataFiltrada}
        completeMethod={buscarTiendas}
        placeholder="Buscar Clientes"
        onChange={(e) => options.filterCallback(e.value)}
        style={{ width: "400px" }}
      />
    );
  };
  //multiLookup
  const autoCompleteRef = React.useRef(null);
  const [where, setWhere] = React.useState({ where: {} });
  const { data } = useBuscarClientesAutoComplete(where);
  const [dataFiltrada, setDataFiltrada] = React.useState(null);
  const [cargando, setCargando] = React.useState(true);
  const buscarTiendas = (event) => {
    setWhere({ where: { Criterio: event.query, CantidadPorPagina: 1000 } });
  };

  //filtro periodos
  const [periodo, setPeriodo] = React.useState(1);
  const periodos = [
    { name: "Actual", value: 1 },
    { name: "Anterior", value: 2 },
    { name: "Otro", value: 3 },
  ];
  const [value, setValue] = React.useState(3);
  const [periodosPredifinidos, setPeriodosPredifinidos] = React.useState([]);
  const actual = [
    { name: "Hoy", value: 1 },
    { name: "Esta Semana", value: 2 },
    { name: "Este Mes", value: 3 },
    { name: "Este Trimestre", value: 4 },
    { name: "Este Año", value: 5 },
  ];
  const anterior = [
    { name: "Ayer", value: 6 },
    { name: "Semana Anterior", value: 7 },
    { name: "Mes Anterior", value: 8 },
    { name: "Trimestre Anterior", value: 9 },
    { name: "Año Anterior", value: 10 },
  ];
  function handleChange(value) {
    setValue(value);
    setCargandoGrid(true);
    let periodo;
    switch (value) {
      case 1:
        periodo = "diario";
        break;
      case 2:
        periodo = "semanal";
        break;
      case 3:
        periodo = "mensual";
        break;
      case 4:
        periodo = "trimestral";
        break;
      case 5:
        periodo = "anual";
        break;
      case 6:
        periodo = "ayer";
        break;
      case 7:
        periodo = "semana anterior";
        break;
      case 8:
        periodo = "mes anterior";
        break;
      case 9:
        periodo = "trimestre anterior";
        break;
      case 10:
        periodo = "ano anterior";
        break;
    }
    setPeriodoGrid(periodo);
    const newWhere = {
      where: {
        ...gridWhere.where,
        periodo: periodo,
        esFecha: false,
      },
    };
    setGridWhere(newWhere);
  }
  const [dates, setDates] = React.useState(null);
  let today = new Date();
  const [verRangoDeFechas, setVerRangoDeFechas] = React.useState(false);

  function setFechas() {
    setValue(null);
    const fechasFormateadas = dates.map((date) => formatDate(date));
    setFechasGrid(fechasFormateadas);
    const newWhere = {
      where: {
        ...gridWhere.where,
        fechaInicio: formatDate(dates[0]),
        fechaFin: formatDate(dates[1]),
        esFecha: true,
      },
    };
    setGridWhere(newWhere);
    setCargandoGrid(true);
  }
  function formatDate(date) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    return day + "/" + month + "/" + year;
  }
  const matchModes = [
    {
      label: "Mayor o igual a",
      value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
    },
    { label: "Menor o igual a", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
  ];
  const header = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div className="p-component">
          <Button
            type="button"
            icon="pi pi-filter-slash"
            label="Limpiar Filtros"
            outlined
            onClick={borrarFiltros}
            id="quitarFiltros"
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            flexDirection: "column",
            alignItems: "center",
            minWidth: "50%",
          }}
        >
          <div style={{ width: "40%", marginBottom: "5px" }}>
            <Dropdown
              value={periodo}
              onChange={(e) => setPeriodo(e.value)}
              options={periodos}
              optionLabel="name"
            />
          </div>

          {verRangoDeFechas ? (
            <div>
              <Calendar
                maxDate={today}
                placeholder="Rango de Fechas"
                dateFormat="dd/mm/yy"
                value={dates}
                selectionMode="range"
                locale="es"
                onChange={(e) => setDates(e.value)}
              />
            </div>
          ) : (
            <SelectButton
              value={value}
              onChange={(e) => handleChange(e.value)}
              optionLabel="name"
              options={periodosPredifinidos}
            />
          )}
        </div>
      <div>
          <Dp as={Nav.Item}>
              <Dp.Toggle
                  as={Nav.Link}
                  id="Dp-company-switch"
                  className="buttonHover"
                  onClick={openExportar}
              >
                  <ToolTip placement="left" message="Exportar">
                      <SvgComponent
                          iconName="export"
                          fill={theme.color1}
                      />
                  </ToolTip>
              </Dp.Toggle>
          </Dp>
      </div>
      </div>
    );
  };
  const colmunasHeaderGruop = [
    //Facturas
    {
      field: "FacturasMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "FacturasCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    {
      field: "FacturasPromedio",
      header: "Promedio",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    //Facturas Pendientes
    {
      field: "FacturaPendienteMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "FacturaPendienteCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    //Facturas Vencidas
    {
      field: "FacturasVencidasMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "FacturasVencidasCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    // Tasas
    {
      field: "TasaMorosidad",
      header: "Tasa de Morosidad",
      dataType: "numeric",
      filterElement: tasasFiltroTemplate,
    },
    {
      field: "TasaImpagos",
      header: "Tasa de Impagos",
      dataType: "numeric",
      filterElement: tasasFiltroTemplate,
    },
    {
      field: "TasaResolucionImpagos",
      header: "Tasa de Resolucion de Impagos",
      dataType: "numeric",
      filterElement: tasasFiltroTemplate,
    },
    {
      field: "CalidadCredito",
      header: "Calidad de Credito",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    {
      field: "PlazoMedioCobro",
      header: "Plazo Medio de Cobro",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    // Descuentos
    {
      field: "FacturasDescuentoMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "FacturasDescuentoCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    {
      field: "FacturaDescuentoPromedio",
      header: "Promedio",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    // Notas de Credito
    {
      field: "NotaCreditoMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "NotaCreditoCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    {
      field: "NotaCreditoPromedio",
      header: "Promedio",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    // Devolucioens
    {
      field: "DevolucionesMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "DevolucionesCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    {
      field: "DevolucionesPromedio",
      header: "Promedio",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    // Notas de Debito
    {
      field: "NotaDebitoMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "NotaDebitoCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    {
      field: "NotaDebitoPromedio",
      header: "Promedio",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    //Anticpos
    {
      field: "AnticipoMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "AnticipoCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    {
      field: "AnticipoPromedio",
      header: "Promedio",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    // Recibos
    {
      field: "RecibosMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "RecibosCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    {
      field: "RecibosPromedio",
      header: "Promedio",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
  ];
  const colmunasDataTable = [
    { field: "_FacturasMontoConSimbolo" },
    { field: "FacturasCantidad" },
    { field: "_FacturasPromedioConSimbolo" },

    { field: "_FacturaPendinteMontoConSimbolo" },
    { field: "FacturaPendienteCantidad" },

    { field: "_FacturasVencidasMontoConSimbolo" },
    { field: "FacturasVencidasCantidad" },

    { field: "_TasaMorosidadPorciento" },
    { field: "_TasaImpagosPorciento" },
    { field: "_TasaResolucionImpagosPorciento" },

    { field: "_CalidadCreditoConSimbolo" },
    { field: "_PlazoMedioCobro" },

    { field: "_FacturaDescuentoMontoConSimbolo" },
    { field: "FacturaDescuentoCantidad" },
    { field: "_FacturaDescuentoPromedioConSimbolo" },

    { field: "_NotaCreditoMontoConSimbolo" },
    { field: "NotaCreditoCantidad" },
    { field: "_NotaCreditoPromedioConSimbolo" },

    { field: "_DevolucionMontoConSimbolo" },
    { field: "DevolucionCantidad" },
    { field: "_DevolucionPromedioConSimbolo" },

    { field: "_NotaDebitoMontoConSimbolo" },
    { field: "NotaDebitoCantidad" },
    { field: "_NotaDebitoPromedioConSimbolos" },

    { field: "_AnticipoMontoConSimbolo" },
    { field: "AnticipoCantidad" },
    { field: "_AnticipoPromedioConSimbolo" },

    { field: "_ReciboMontoConSimbolo" },
    { field: "ReciboCantidad" },
    { field: "_ReciboPromedioConSimbolo" },
  ];
  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column colSpan={2} />
        <Column header="Facturas" colSpan={3} />
        <Column header="Facturas Pendientes" colSpan={2} />
        <Column header="Facturas Vencidas" colSpan={2} />
        <Column header="Tasas" colSpan={3} />
        <Column header="Calidad de Credito" colSpan={1}/>
        <Column header="Plazo Medio de Cobro" colSpan={1} />
        <Column header="Descuentos" colSpan={3} />
        <Column header="Notas de Credito" colSpan={3} />
        <Column header="Devoluciones" colSpan={3} />
        <Column header="Notas de Debito" colSpan={3} />
        <Column header="Anticpos" colSpan={3} />
        <Column header="Recibos" colSpan={3} />
      </Row>
      <Row>
        <Column
          style={{ textAlign: "right" }}
          sortable
          field="IdSec"
          header="ID"
        />
        <Column
          style={{ minWidth: "15rem" }}
          sortable
          field="Nombre"
          header="Clientes"
          showFilterMatchModes={false}
          filter
          filterField="Nombre"
          filterElement={NombreFiltroTemplate}
          pt={{
            filterMenuButton: { className: "p-component" },
            filterButtonbar: { className: "test" },
          }}
        />
        {colmunasHeaderGruop.map((col, i) => (
          <Column
            style={{ minWidth: "5rem" }}
            pt={{
              filterMenuButton: { className: "p-component" },
              filterButtonbar: { className: "test" },
            }}
            sortable
            field={col.field}
            header={col.header}
            filter
            sortField={col.field}
            filterField={col.field}
            filterElement={col.filterElement}
            dataType={col.dataType}
            showFilterOperator={false}
            filterMatchModeOptions={matchModes}
          />
        ))}
      </Row>
    </ColumnGroup>
  );

    const openExportar = () => {
        setShowExportar(true);
    };
    
    // useEffect
  React.useEffect(() => {
    locale("es");
    initFiltros();
  }, []);
  React.useEffect(() => {
    if (data) {
      let _tiendasFiltradas = [];
      _tiendasFiltradas = data.Resultados.map((e) => {
        return e.text;
      });
      setDataFiltrada(_tiendasFiltradas);
    }
  }, [data]);
  React.useEffect(() => {
    if (tiendasGrid && !errorTiendasGrid) {
      setTotalRecords(tiendasGrid.total);
      setCargando(false);
      setCargandoGrid(false);
    } else if (tiendasGrid) {
      setTotalRecords(tiendasGrid.total);
      setCargando(false);
      setCargandoGrid(false);
    }
  }, [tiendasGrid]);
  React.useEffect(() => {
    if (dates) {
      if (dates[0] !== null && dates[1] !== null) {
        setFechas();
      }
    }
  }, [dates]);
  React.useEffect(() => {
    if (periodo == 1) {
      setPeriodosPredifinidos(actual);
      setVerRangoDeFechas(false);
    } else if (periodo == 2) {
      setPeriodosPredifinidos(anterior);
      setVerRangoDeFechas(false);
    } else {
      setVerRangoDeFechas(true);
    }
  }, [periodo]);
  React.useEffect(() => {
    setlazyState({
      ...lazyState,
      filters: filtros,
    });
  }, [filtros]);

  return (
    <div className="new-p-table">
      {cargando ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ProgressSpinner />
        </div>
      ) : (
        <>
            {showExportar && createPortal(
                <Exportar
                    PROPIEDADES_EXPORTAR={[
                        {value: 'IdSec', label: 'Id'},
                        {value: 'Nombre', label: 'Cliente'},
                        {value: 'FacturasMonto', label: 'Facturas Monto total'},
                        {value: 'FacturasCantidad', label: 'Facturas Cantidad'},
                        {value: 'FacturasPromedio', label: 'Facturas Promedio'},
                        {value: 'FacturaPendienteMonto', label: 'Factura Pendiente Monto total'},
                        {value: 'FacturaPendienteCantidad', label: 'Factura Pendiente Cantidad'},
                        {value: 'FacturasVencidasMonto', label: 'Facturas Vencidas Monto total'},
                        {value: 'FacturasVencidasCantidad', label: 'Facturas Vencidas Cantidad'},
                        {value: 'TasaMorosidad', label: 'Tasa Morosidad'},
                        {value: 'TasaImpagos', label: 'Tasa Impagos'},
                        {value: 'TasaResolucionImpagos', label: 'Tasa Resolucion Impagos'},
                        {value: 'CalidadCredito', label: 'Calidad Credito'},
                        {value: 'PlazoMedioCobro', label: 'Plazo Medio Cobro'},
                        {value: 'FacturasDescuentoMonto', label: 'Facturas Descuento Monto total'},
                        {value: 'FacturasDescuentoCantidad', label: 'Facturas Descuento Cantidad'},
                        {value: 'FacturaDescuentoPromedio', label: 'Factura Descuento Promedio'},
                        {value: 'NotaCreditoMonto', label: 'Nota Credito Monto total'},
                        {value: 'NotaCreditoCantidad', label: 'Nota Credito Cantidad'},
                        {value: 'NotaCreditoPromedio', label: 'Nota Credito Promedio'},
                        {value: 'DevolucionesMonto', label: 'Devoluciones Monto total'},
                        {value: 'DevolucionesCantidad', label: 'Devoluciones Cantidad'},
                        {value: 'DevolucionesPromedio', label: 'Devoluciones Promedio'},
                        {value: 'NotaDebitoMonto', label: 'Nota Debito Monto total'},
                        {value: 'NotaDebitoCantidad', label: 'Nota Debito Cantidad'},
                        {value: 'NotaDebitoPromedio', label: 'Nota Debito Promedio'},
                        {value: 'AnticipoMonto', label: 'Anticipo Monto total'},
                        {value: 'AnticipoCantidad', label: 'Anticipo Cantidad'},
                        {value: 'AnticipoPromedio', label: 'Anticipo Promedio'},
                        {value: 'ReciboMonto', label: 'Recibo Monto total'},
                        {value: 'ReciboCantidad', label: 'Recibo Cantidad'},
                        {value: 'ReciboPromedio', label: 'Recibo Promedio'},
                    ]}
                    where={{...gridWhere.where}}
                    showExportar={showExportar}
                    setShowExportar={setShowExportar}
                    exportarCallBack={exportarClientesGrid}
                >
                </Exportar>,
                window.parent.document.querySelector("#sidebarContainer")
            )}
          <div>
            {errorTiendasGrid && (
              <Message
                severity="warn"
                text={errorTiendasGrid?.Mensaje}
                style={{ width: "100%", marginBottom: "10px" }}
              />
            )}
          </div>
          <DataTable
            showGridlines
            headerColumnGroup={headerGroup}
            header={header}
            onFilter={onFilter}
            filters={lazyState.filters}
            value={tiendasGrid.clientes}
            lazy
            first={lazyState.first}
            rows={25}
            loading={cargandoData}
            paginator
            totalRecords={totalRecords}
            onPage={onPage}
            onSort={onSort}
            sortField={lazyState.sortField}
            sortOrder={lazyState.sortOrder}
            tableStyle={{ minWidth: "50rem" }}
            stripedRows
            size="small"
            emptyMessage="No hay resultados disponibles."
            resizableColumns
            columnResizeMode="expand"
            pt={{
              paginator: {
                pageButton: "p-component",
                nextPageButton: "p-component",
                lastPageButton: "p-component",
                prevPageButton: "p-component",
                firstPageButton: "p-component",
              },
            }}
          >
            <Column field="IdSec" style={{ textAlign: "right" }} />
            <Column field="Nombre" />
            {colmunasDataTable.map((col, i) => (
              <Column field={col.field} style={{ textAlign: "right" }} />
            ))}
          </DataTable>
        </>
      )}
    </div>
  );
};
